import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
  Messaging,
} from "firebase/messaging";
const firebaseConfig = {
  apiKey: "AIzaSyCN0HaGLy4iJqSFU4SeDr4-XOq9x_oAfQk",
  authDomain: "cohesive-point-456011-d9.firebaseapp.com",
  projectId: "cohesive-point-456011-d9",
  storageBucket: "cohesive-point-456011-d9.firebasestorage.app",
  messagingSenderId: "777441045557",
  appId: "1:777441045557:web:ee340f3d77e6345c66d57c",
};

const app = initializeApp(firebaseConfig, "My App");
const db = getFirestore(app);
let messaging: Messaging | null = null;

const initializeMessaging = async () => {
  if (typeof window !== "undefined" && (await isSupported())) {
    messaging = getMessaging(app);
    console.log("Firebase Messaging is supported!");
    return messaging;
  } else {
    console.log("Firebase Messaging is not supported in this environment.");
    return null;
  }
};

const generateToken = async () => {
  // Ensure messaging is initialized first
  const messagingInstance = messaging || (await initializeMessaging());
  if (!messagingInstance) {
    console.error("Firebase Messaging is not supported");
    return null; // Return null instead of throwing
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      try {
        // Add a check for production environment
        const swUrl = "/firebase-messaging-sw.js";
        console.log(`Registering service worker from: ${swUrl}`);

        const registration = await navigator.serviceWorker.register(swUrl, {
          scope: "/", // Explicitly set the scope
        });

        await navigator.serviceWorker.ready;

        const token = await getToken(messagingInstance, {
          vapidKey:
            "BN_K1_FaUywRNQxije1LYsR7ZDyLSSK_ds1Um8Nznu5G4i1cotPSLIZaNt79geo5kI4BOG5yGwGlEVEg-TieQw4",
          serviceWorkerRegistration: registration,
        });
        return token;
      } catch (error) {
        console.error("Error getting FCM token:", error);
        return null; // Return null instead of throwing
      }
    }
    console.warn("Notification permission denied");
    return null; // Return null instead of throwing
  } catch (error) {
    console.error("Error in generateToken:", error);
    return null; // Return null instead of throwing
  }
};

// generateToken() must be called only in response to a user gesture (e.g. button click / form submit)

export { messaging, getToken, onMessage, app, db, generateToken, initializeMessaging };
